module.exports = __webpack_public_path__ + "img/melting_1200x800.489d4d21.svg";